export const delay = (method: () => void, millisecond: number) => {
  const a = setTimeout(() => {
    method();
    clearTimeout(a);
  }, millisecond);
};

export const scrollTopToElement = (targetElement: HTMLElement, behavior?: ScrollBehavior) => {
  if (targetElement) {
    const rect = targetElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (isIE()) {
      window.scrollTo(0, rect.top + scrollTop);
    } else {
      window.scrollTo({
        top: rect.top + scrollTop,
        behavior: behavior ? behavior : 'smooth',
      });
    }
  }
};

export const isIE = (): boolean => {
  const userAgent = navigator.userAgent;
  const ieUpTo10: boolean = /MSIE \d/.test(userAgent);
  const ie11Up: boolean = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.test(userAgent);
  const edge: boolean = /Edge\/(\d+)/.test(userAgent);
  return ieUpTo10 || ie11Up || edge;
};

export const isIPhone = (): boolean => {
  return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
}
export const hasTouchScreen = (): boolean => {
  const checkUserAgent: boolean = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  let result = false;
  if ('maxTouchPoints' in navigator) {
    result = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    result = navigator['msMaxTouchPoints'] > 0;
  } else {
    const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      result = !!mQ.matches;
    } else if ('orientation' in window) {
      result = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      result = checkUserAgent;
    }
  }
  return result;
};
